const GENERIC_TAX_PROFILE = 'XAXX010101000';
const FOREIGN_GENERIC_TAX_PROFILE = 'XEXX010101000';
const GENERIC_TAX_PROFILES = [GENERIC_TAX_PROFILE, FOREIGN_GENERIC_TAX_PROFILE];
const LINK_RFC_VALIDATION = 'https://www.sat.gob.mx/aplicacion/operacion/29073/verifica-si-estas-registrado-en-el-rfc';

export { GENERIC_TAX_PROFILE, GENERIC_TAX_PROFILES, LINK_RFC_VALIDATION };


// WEBPACK FOOTER //
// ./src/constants/customer.js